import { takeEvery, fork, put, all, call } from 'redux-saga/effects';
import { UPDATE_DATA_RETENTION_POLICY } from './actionTypes';
import { updateDataRetentionPolicySuccess, updateDataRetentionPolicyError } from './actions';
import { getDataRetentionAPI } from '../../../api/dataRetention';

const dataRetentionAPI = getDataRetentionAPI();

function* updateDataRetentionPolicy({ payload: { user, id, fields } }) {
  try {
    const response = yield call(dataRetentionAPI.updatePolicy, user.token, id, fields);
    yield put(updateDataRetentionPolicySuccess(response.message));
  } catch (error) {
    yield put(updateDataRetentionPolicyError(error));
  }
}

export function* watchUpdateDataRetentionPolicy() {
  yield takeEvery(UPDATE_DATA_RETENTION_POLICY, updateDataRetentionPolicy);
}

function* updateDataRetentionPolicySaga() {
  yield all([fork(watchUpdateDataRetentionPolicy)]);
}

export default updateDataRetentionPolicySaga;
